'use strict';

/**
*  The function for birthday validation
*  It creates the space  between the month and date with frontslash and allows only number to enter
*/

var birthdayValidation = function (evt) {
    let targetValue = evt.target.value;
    var key = evt.keyCode || evt.charCode;

    // It checks the entered key for backspace
    if ((key === 37 || key === 8 || key === 46) || (targetValue.indexOf('/') !== -1 && (evt.target.selectionStart === 0 || evt.target.selectionStart === 1))) {
        return false;
    }

    if (targetValue.length === 2 && targetValue.indexOf('/') !== -1 && targetValue.indexOf('0') === -1) {
        evt.target.value = '0' + targetValue; // eslint-disable-line no-param-reassign
    }

   // Managing the removal of frontslash
    if (targetValue.length === 3) {
        if (targetValue.indexOf(' ') !== -1) {
            evt.target.value = evt.target.value.replace(/[^\d]/g, '').replace(/(.{2})/g, '$1').trim(); // eslint-disable-line no-param-reassign
        } else {
            evt.target.value = evt.target.value.replace(/[^\d]/g, '').replace(/(.{2})/g, '$1 / ').trim(); // eslint-disable-line no-param-reassign
        }
    } else {
        evt.target.value = evt.target.value.replace(/[^\d]/g, '').replace(/(.{2})/g, '$1 / ').trim(); // eslint-disable-line no-param-reassign
    }

    // replaces the last extra frontslash
    if (evt.target.value.length > 8) {
        evt.target.value = evt.target.value.replace(/\/([^/]*)$/, '$1').trim(); // eslint-disable-line no-param-reassign
    }

    return true;
};

/**
*  The function for validate month and date
*  @param {Object} bdate - form input.
*/
var monthDateValidation = function (bdate) {
    var $bdateField = $(bdate);
    var birthdateValue = $bdateField.val();
    if (birthdateValue) {
        var birthArr = birthdateValue.trim().split('/');
        var valid = false;
        var radix = 10;
        var month = parseInt(birthArr[1], radix);
        var day = parseInt(birthArr[0], radix);
        var thirty30 = [4, 6, 9, 11];
        var thirty31 = [1, 3, 5, 7, 8, 10, 12];

        if ((month === parseInt('02', radix) && day <= parseInt('29', radix)) || ($.inArray(month, thirty30) !== -1 && day <= parseInt('30', radix)) || ($.inArray(month, thirty31) !== -1 && day <= parseInt('31', radix))) {
            valid = true;
        }

        if (!valid) {
            var dataError = $bdateField.data('pattern-mismatch');
            $bdateField.removeClass('is-invalid');
            $bdateField.addClass('is-invalid');
            $bdateField.siblings('.invalid-feedback').html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + dataError + '</span>').css('display', 'block');
        }
    }
};

/**
 * Validate a form element. Requires `this` to be set to form object
* @param {jQuery.event} input - form input.
 * @returns {boolean} - Flag to indicate if form is valid
 */
var validateFormElement = function (input) {
    var valid = true;
    if (($(input).data('must-match') && $('#' + $(input).data('must-match')).length)
        && $('#' + $(input).data('must-match')).val().length
        && $(input).val().toLowerCase() !== $('#' + $(input).data('must-match')).val().toLowerCase()) {
        valid = false;
        if ($(input).data('match-error')) {
            $(input).data('custom-error', ($(input).data('match-error')));
        } else {
            $(input).data('custom-error', 'Fields do not match');
        }
        $(input).trigger('invalid', input.validity);
    }

    return valid;
};

/**
* match both mail inputs it is required validation while key press of mail inputs to enable and disable btn
* @param {Object} mailInput - confirm email input
*/
var validateMail = function (mailInput) {
    if (mailInput.val().trim() !== '') {
        if (validateFormElement(mailInput[0])) {
            mailInput.parent().find('.invalid-feedback').hide();
            mailInput.removeClass('is-invalid');
        }
    }
};

/**
* check input elements are empty or invalid
* @param {Object} allFormInp - all inputs or required inputs in form
* @returns {boolean} - Return true if any input element is empty or has class is-invalid
*/
var checkForEmptyAndInValidInput = function (allFormInp) {
    return allFormInp.some((inputEle)=> {
        return (inputEle.value.trim() === '' || inputEle.classList.contains('is-invalid'));
    });
};

/**
* check gift form is filled
* @param {Object} formSelector - form selector classname or id
* @param {Object} confirmMailInputSelector - confirm Email Input classname or id, Input Validation while typing in mail inputs
* @returns {boolean} - Return true if gift form is not filled
*/
var checkFormIsNotFilled = function (formSelector, confirmMailInputSelector) {
    const $form = document.querySelector(formSelector);
    let formNotfilled = true;
    if ($form) {
        const $confirmMailInput = $(confirmMailInputSelector);
        if ($confirmMailInput.length) {
            validateMail($confirmMailInput);
        }
        const $allReqInputs = $form.querySelectorAll('input[required]');
        formNotfilled = checkForEmptyAndInValidInput(Array.from($allReqInputs));
    }
    return formNotfilled;
};

module.exports = {
    birthdayValidation: birthdayValidation,
    monthDateValidation: monthDateValidation,
    validateFormElement: validateFormElement,
    checkFormIsNotFilled: checkFormIsNotFilled
};
